module.exports = __webpack_public_path__ + "static/media/nodejs.55e83371.png";